import { RightSideBloodOrderTranslations } from "./types";

export const deTranslations: RightSideBloodOrderTranslations = {
    selectedItems: "Ausgewählte Werte/Profile",
    reason: "Grund für die Blutbestellung",
    submitOrder: "Werte anfordern"
};